import { render, staticRenderFns } from "./DramaConfig.vue?vue&type=template&id=ce04a1e6&scoped=true"
import script from "./DramaConfig.vue?vue&type=script&lang=js"
export * from "./DramaConfig.vue?vue&type=script&lang=js"
import style0 from "./DramaConfig.vue?vue&type=style&index=0&id=ce04a1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce04a1e6",
  null
  
)

export default component.exports